import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {CurrencyModel} from './CurrencyModel';
import {DesignServicesModel} from './DesignServicesModel';
import {ProviderModel} from './ProviderModel';
import {ContractualDataModel} from './ContractualDataModel';
import {DiscountModel} from './DiscountModel';
import {DeltaVolumiModel} from './DeltaVolumiModel';
import {ConsuntivoVolumiModel} from './ConsuntivoVolumiModel';
import {ServiceChangesModel} from './ServiceChangesModel';
import {CalculatedChargeModel} from './CalculatedChargeModel';
import {DeltaChargesModel} from './DeltaChargesModel';
import {ArchitectureStructureSettingModel} from './ArchitectureStructureSettingModel';
import {LayerModel} from './LayerModel';
import {L1Model} from './L1Model';
import {L2Model} from './L2Model';
import {L3Model} from './L3Model';
import {UnitsModel} from './UnitsModel';
import {ConsuntivoChargesModel} from './ConsuntivoChargesModel';
import {ContractSettingsModel} from './ContractSettingsModel';
import {LocalCustomerSettingsModel} from './LocalCustomerSettingsModel';
import {CurrencySettingModel} from './CurrencySettingModel';
import {ForecastVolumiModel} from './ForecastVolumiModel';
import {SizeModel} from './SizeModel';
import {SiteModel} from './SiteModel';
import {ShareNameDeviceModel} from './ShareNameDeviceModel';
import {ReimbursmentModel} from './ReimbursmentModel';
import {TerminationFeeModel} from './TerminationFeeModel';
import {TransformationModel} from './TransformationModel';
import { ServiceVariantModel } from './ServiceVariantModel';
import {RateCardModel} from './RateCardModel';
import {RoleAnagrafModel} from './RoleAnagrafModel';
import {RateTypeModel} from './RateTypeModel';


export class AllSettingsFilterModel {
  region: RegionModel = null;
  localCustomer: LocalCustomerModel = null;
  resourceUnit: ResourcesUnitModel = null;
  contractType: ContractTypeModel = null;
  currency: CurrencyModel = null;
  provider: ProviderModel = null;
  sl1: DesignServicesModel = null;
  sl2: LayerModel = null;
  sl3: L1Model = null;
  sl4: L2Model = null;
  sl5: L3Model = null;
  unit: UnitsModel = null;
  numAnno: number;
  isDeltaSignificativo: number;
  isClaims: number;
  isRecovery: number;
  shareName: string;
  applicationDescription: string;
  applicationCod: string;
  size: SizeModel;
  site: SiteModel;
  roles: RoleAnagrafModel = null;
  rateType: RateTypeModel = null;
  shareNameDevice: ShareNameDeviceModel;
  serviceVariant: ServiceVariantModel = null;

  regionList: Array<RegionModel> = new Array<RegionModel>();
  localCustomerList: Array<LocalCustomerModel> = new Array<LocalCustomerModel>();
  contractTypeList: Array<ContractTypeModel> = new Array<ContractTypeModel>();
  providerList: Array<ProviderModel> = new Array<ProviderModel>();
  sizeList: Array<SizeModel> = new Array<SizeModel>();

  constructor(region?: RegionModel, localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              provider?: ProviderModel,
              contractType?: ContractTypeModel,
              currency?: CurrencyModel,
              sl1?: DesignServicesModel,
              sl2?: LayerModel,
              sl3?: L1Model,
              sl4?: L2Model,
              sl5?: L3Model,
              unit?: UnitsModel,
              numAnno?: number, isDeltaSignificativo?: number,
              isClaims?: number, isRecovery?: number,
              shareName?: string, applicationDescription?: string,
              applicationCod?: string, size?: SizeModel,
              site?: SiteModel, shareNameDevice?: ShareNameDeviceModel,
              serviceVariant?: ServiceVariantModel, roleRateCard?: RoleAnagrafModel,
              rateType?: RateTypeModel) {

    if (region !== undefined) {
      this.region = region;
    }

    if (localCustomer !== undefined) {
      this.localCustomer = localCustomer;
    }

    if (resourceUnit !== undefined) {
      this.resourceUnit = resourceUnit;
    }

    if (contractType !== undefined) {
      this.contractType = contractType;
    }

    if (currency !== undefined) {
      this.currency = currency;
    }

    if (sl1 !== undefined) {
      this.sl1 = sl1;
    }

    if (provider !== undefined) {
      this.provider = provider;
    }

    if (sl2 !== undefined) {
      this.sl2 = sl2;
    }

    if (sl3 !== undefined) {
      this.sl3 = sl3;
    }

    if (sl4 !== undefined) {
      this.sl4 = sl4;
    }

    if (sl5 !== undefined) {
      this.sl5 = sl5;
    }

    if (unit !== undefined) {
      this.unit = unit;
    }
    if (numAnno !== numAnno) {
      this.numAnno = numAnno;
    }

    if (isDeltaSignificativo !== isDeltaSignificativo) {
      this.isDeltaSignificativo = isDeltaSignificativo;
    }

    if (isClaims !== isClaims) {
      this.isClaims = isClaims;
    }

    if (isRecovery !== isRecovery) {
      this.isRecovery = isRecovery;
    }

    if (shareName !== shareName) {
      this.shareName = shareName;
    }

    if (applicationDescription !== applicationDescription) {
      this.applicationDescription = applicationDescription;
    }

    if (applicationCod !== applicationCod) {
      this.applicationCod = applicationCod;
    }

    if (size !== size) {
      this.size = size;
    }

    if (site !== site) {
      this.site = site;
    }

    if (shareNameDevice !== shareNameDevice) {
      this.shareNameDevice = shareNameDevice;
    }

    if (serviceVariant !== undefined) {
      this.serviceVariant = serviceVariant;
    }

    if (roleRateCard !== undefined) {
      this.roles = roleRateCard;
    }

    if (rateType !== undefined) {
      this.rateType = rateType;
    }
  }

  public static getFromLogin(): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    return allInSettingsFilter;
  }

  // CONTRACTUAL DATA
  public static getFromContractualDataModel(contractualDataModel: ContractualDataModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = contractualDataModel.numAnnoMese ? contractualDataModel.numAnnoMese : null;
    allInSettingsFilter.region = contractualDataModel.region ? contractualDataModel.region : null;
    allInSettingsFilter.localCustomer = contractualDataModel.localCustomer ? contractualDataModel.localCustomer : null;
    allInSettingsFilter.contractType = contractualDataModel.contractType ? contractualDataModel.contractType : null;
    allInSettingsFilter.sl1 = contractualDataModel.designServices ? contractualDataModel.designServices : null;
    allInSettingsFilter.provider = contractualDataModel.provider ? contractualDataModel.provider : null;
    allInSettingsFilter.resourceUnit = contractualDataModel.resourceUnit ? contractualDataModel.resourceUnit : null;

    return allInSettingsFilter;
  }

  public static getFromDiscoutModel(discountModel: DiscountModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.provider = discountModel.provider ? discountModel.provider : null;
    allInSettingsFilter.region = discountModel.region ? discountModel.region : null;
    allInSettingsFilter.localCustomer = discountModel.localCustomer ? discountModel.localCustomer : null;
    allInSettingsFilter.numAnno = discountModel.numAnno ? discountModel.numAnno : null;

    return allInSettingsFilter;
  }

  public static getFromRateCardModel(rateCardModel: RateCardModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.region = rateCardModel.region ? rateCardModel.region : null;
    allInSettingsFilter.currency = rateCardModel.currency ? rateCardModel.currency : null;
    allInSettingsFilter.rateType = rateCardModel.rateType ? rateCardModel.rateType : null;
    allInSettingsFilter.roles = rateCardModel.roles ? rateCardModel.roles : null;

    return allInSettingsFilter;
  }

  public static getFromReimbursmentModel(reimbursmentDataModel: ReimbursmentModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = reimbursmentDataModel.numAnnoMese ? reimbursmentDataModel.numAnnoMese : null;
    allInSettingsFilter.region = reimbursmentDataModel.region ? reimbursmentDataModel.region : null;
    allInSettingsFilter.localCustomer = reimbursmentDataModel.localCustomer ? reimbursmentDataModel.localCustomer : null;
    allInSettingsFilter.provider = reimbursmentDataModel.provider ? reimbursmentDataModel.provider : null;

    return allInSettingsFilter;
  }

  public static getFromTerminationFeeModel(terminationFeeModel: TerminationFeeModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = terminationFeeModel.numAnnoMese ? terminationFeeModel.numAnnoMese : null;
    allInSettingsFilter.region = terminationFeeModel.region ? terminationFeeModel.region : null;
    allInSettingsFilter.localCustomer = terminationFeeModel.localCustomer ? terminationFeeModel.localCustomer : null;
    allInSettingsFilter.provider = terminationFeeModel.provider ? terminationFeeModel.provider : null;
    allInSettingsFilter.contractType = terminationFeeModel.contractType ? terminationFeeModel.contractType : null;

    return allInSettingsFilter;
  }

  public static getFromTransformationModel(transformationModel: TransformationModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.region = transformationModel.region ? transformationModel.region : null;
    allInSettingsFilter.localCustomer = transformationModel.localCustomer ? transformationModel.localCustomer : null;
    allInSettingsFilter.provider = transformationModel.provider ? transformationModel.provider : null;
    allInSettingsFilter.contractType = transformationModel.contractType ? transformationModel.contractType : null;

    return allInSettingsFilter;
  }

  public static getFromServiceChangesModel(serviceChangesModel: ServiceChangesModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = serviceChangesModel.numAnnoMese ? serviceChangesModel.numAnnoMese : null;
    allInSettingsFilter.provider = serviceChangesModel.provider ? serviceChangesModel.provider : null;
    allInSettingsFilter.localCustomer = serviceChangesModel.localCustomer ? serviceChangesModel.localCustomer : null;
    allInSettingsFilter.contractType = serviceChangesModel.contractType ? serviceChangesModel.contractType : null;
    allInSettingsFilter.sl1 = serviceChangesModel.designServices ? serviceChangesModel.designServices : null;
    allInSettingsFilter.resourceUnit = serviceChangesModel.resourceUnit ? serviceChangesModel.resourceUnit : null;
    allInSettingsFilter.resourceUnit = serviceChangesModel.resourceUnit ? serviceChangesModel.resourceUnit : null;
    allInSettingsFilter.shareName = serviceChangesModel.shareName ? serviceChangesModel.shareName : null;
    allInSettingsFilter.applicationCod = serviceChangesModel.applicationCod ? serviceChangesModel.applicationCod : null;

    return allInSettingsFilter;
  }

  public static getFromForecastVolumiModel(forecastVolumiModel: ForecastVolumiModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = forecastVolumiModel.numAnnoMese ? forecastVolumiModel.numAnnoMese : null;
    allInSettingsFilter.region = forecastVolumiModel.region ? forecastVolumiModel.region : null;
    allInSettingsFilter.localCustomer = forecastVolumiModel.localCustomer ? forecastVolumiModel.localCustomer : null;
    allInSettingsFilter.contractType = forecastVolumiModel.contractType ? forecastVolumiModel.contractType : null;
    allInSettingsFilter.resourceUnit = forecastVolumiModel.resourceUnit ? forecastVolumiModel.resourceUnit : null;
    allInSettingsFilter.provider = forecastVolumiModel.provider ? forecastVolumiModel.provider : null;

    return allInSettingsFilter;
  }

  public static getFromConsuntivoVolumiModel(consumptiveVolumeModel: ConsuntivoVolumiModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = consumptiveVolumeModel.numAnnoMese ? consumptiveVolumeModel.numAnnoMese : null;
    allInSettingsFilter.region = consumptiveVolumeModel.region ? consumptiveVolumeModel.region : null;
    allInSettingsFilter.localCustomer = consumptiveVolumeModel.localCustomer ? consumptiveVolumeModel.localCustomer : null;
    allInSettingsFilter.contractType = consumptiveVolumeModel.contractType ? consumptiveVolumeModel.contractType : null;
    allInSettingsFilter.resourceUnit = consumptiveVolumeModel.resourceUnit ? consumptiveVolumeModel.resourceUnit : null;
    allInSettingsFilter.sl1 = consumptiveVolumeModel.designServices ? consumptiveVolumeModel.designServices : null;
    allInSettingsFilter.provider = consumptiveVolumeModel.provider ? consumptiveVolumeModel.provider : null;
    allInSettingsFilter.isRecovery = consumptiveVolumeModel.isRecovery ? consumptiveVolumeModel.isRecovery : null;
    allInSettingsFilter.shareName = consumptiveVolumeModel.shareName ? consumptiveVolumeModel.shareName : null;
    allInSettingsFilter.applicationDescription = consumptiveVolumeModel.applicationDescription ?
                                                 consumptiveVolumeModel.applicationDescription : null;

    return allInSettingsFilter;
  }

  public static getFromConsuntivoChargesModel(consumptiveChargeModel: ConsuntivoChargesModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = consumptiveChargeModel.numAnnoMese ? consumptiveChargeModel.numAnnoMese : null;
    allInSettingsFilter.provider = consumptiveChargeModel.provider ? consumptiveChargeModel.provider : null;
    allInSettingsFilter.region = consumptiveChargeModel.region ? consumptiveChargeModel.region : null;
    allInSettingsFilter.localCustomer = consumptiveChargeModel.localCustomer ? consumptiveChargeModel.localCustomer : null;
    allInSettingsFilter.resourceUnit = consumptiveChargeModel.resourceUnit ? consumptiveChargeModel.resourceUnit : null;
    allInSettingsFilter.contractType = consumptiveChargeModel.contractType ? consumptiveChargeModel.contractType : null;
    allInSettingsFilter.isRecovery = consumptiveChargeModel.isRecovery ? consumptiveChargeModel.isRecovery : null;

    return allInSettingsFilter;
  }

  public static getFromDeltaVolumesModel(deltaVolumesModel: DeltaVolumiModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = deltaVolumesModel.numAnnoMese ? deltaVolumesModel.numAnnoMese : null;
    allInSettingsFilter.provider = deltaVolumesModel.provider ? deltaVolumesModel.provider : null;
    allInSettingsFilter.region = deltaVolumesModel.region ? deltaVolumesModel.region : null;
    allInSettingsFilter.localCustomer = deltaVolumesModel.localCustomer ? deltaVolumesModel.localCustomer : null;
    allInSettingsFilter.contractType = deltaVolumesModel.contractType ? deltaVolumesModel.contractType : null;
    allInSettingsFilter.sl1 = deltaVolumesModel.designServices ? deltaVolumesModel.designServices : null;
    allInSettingsFilter.isDeltaSignificativo = deltaVolumesModel.isDeltaSignificativo ? deltaVolumesModel.isDeltaSignificativo : null;
    allInSettingsFilter.isClaims = deltaVolumesModel.isClaims ? deltaVolumesModel.isClaims : null;
    allInSettingsFilter.isRecovery = deltaVolumesModel.isRecovery ? deltaVolumesModel.isRecovery : null;

    return allInSettingsFilter;
  }

  public static getFromCalculatedChargeModel(calculatedChargesModel: CalculatedChargeModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = calculatedChargesModel.numAnnoMese ? calculatedChargesModel.numAnnoMese : null;
    allInSettingsFilter.region = calculatedChargesModel.region ? calculatedChargesModel.region : null;
    allInSettingsFilter.localCustomer = calculatedChargesModel.localCustomer ? calculatedChargesModel.localCustomer : null;
    allInSettingsFilter.contractType = calculatedChargesModel.contractType ? calculatedChargesModel.contractType : null;
    allInSettingsFilter.provider = calculatedChargesModel.provider ? calculatedChargesModel.provider : null;

    return allInSettingsFilter;
  }

  public static getFromDeltaChargesModel(deltaChargesModel: DeltaChargesModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.numAnno = deltaChargesModel.numAnnoMese ? deltaChargesModel.numAnnoMese : null;
    allInSettingsFilter.region = deltaChargesModel.region ? deltaChargesModel.region : null;
    allInSettingsFilter.localCustomer = deltaChargesModel.localCustomer ? deltaChargesModel.localCustomer : null;
    allInSettingsFilter.contractType = deltaChargesModel.contractType ? deltaChargesModel.contractType : null;
    allInSettingsFilter.provider = deltaChargesModel.provider ? deltaChargesModel.provider : null;

    return allInSettingsFilter;
  }

  // tslint:disable-next-line:max-line-length
  public static getFromArchitectureStructureSettingModel(architectureStructureSettingModel: ArchitectureStructureSettingModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.provider = architectureStructureSettingModel.provider ? architectureStructureSettingModel.provider : null;
    allInSettingsFilter.sl2 = architectureStructureSettingModel.layer ? architectureStructureSettingModel.layer : null;
    allInSettingsFilter.sl3 = architectureStructureSettingModel.l1 ? architectureStructureSettingModel.l1 : null;
    allInSettingsFilter.sl4 = architectureStructureSettingModel.l2 ? architectureStructureSettingModel.l2 : null;
    allInSettingsFilter.sl5 = architectureStructureSettingModel.l3 ? architectureStructureSettingModel.l3 : null;
    allInSettingsFilter.unit = architectureStructureSettingModel.units ? architectureStructureSettingModel.units : null;
    allInSettingsFilter.sl1 = architectureStructureSettingModel.designServices ? architectureStructureSettingModel.designServices : null;
    allInSettingsFilter.resourceUnit = architectureStructureSettingModel.resourceUnit ?
                                       architectureStructureSettingModel.resourceUnit : null;

    return allInSettingsFilter;
  }

  public static getFromLocalCustomerSettingsModel(localCustomerSettingsModel: LocalCustomerSettingsModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.localCustomer = localCustomerSettingsModel.localCustomer ? localCustomerSettingsModel.localCustomer : null;
    allInSettingsFilter.region = localCustomerSettingsModel.region ? localCustomerSettingsModel.region : null;

    return allInSettingsFilter;
  }

  public static getFromCurrencySettingsModel(currencySettingsModel: CurrencySettingModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();

    allInSettingsFilter.region = currencySettingsModel.region ? currencySettingsModel.region : null;
    allInSettingsFilter.currency = currencySettingsModel.currency ? currencySettingsModel.currency : null;

    return allInSettingsFilter;
  }

  public static getFromContractSettingsModel(contractSettingsModel: ContractSettingsModel): AllSettingsFilterModel {
    const allInSettingsFilter: AllSettingsFilterModel = new AllSettingsFilterModel();
    allInSettingsFilter.region = contractSettingsModel.region ? contractSettingsModel.region : null;
    allInSettingsFilter.contractType = contractSettingsModel.contractType ? contractSettingsModel.contractType : null;
    allInSettingsFilter.provider = contractSettingsModel.provider ? contractSettingsModel.provider : null;
    return allInSettingsFilter;
  }



}
